import { Component, Input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'split-control-errors',
  templateUrl: './split-control-errors.component.html',
  styleUrls: ['./split-control-errors.component.scss']
})
export class SplitControlErrorsComponent {
  @Input() control!: AbstractControl | null;
}
